import { AfterViewInit } from '@angular/core';
import { MobileCompareVersionsComponent } from './../../compare-versions/compare-versions.component';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { MainService } from 'src/app/Services/service.service';
import { Component, OnInit, ElementRef, ViewChild, Renderer2, ViewEncapsulation } from '@angular/core';
import { MatSidenav } from '@angular/material';
import { ActionService } from './../../../action.service';
import * as WebFont from 'webfontloader';

@Component({
  selector: 'app-mobile-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class HeaderComponent implements OnInit, AfterViewInit {
  
  public enableSubscription:boolean = false;
  public enableCompareVersion:boolean = false;
  public enableLetOurPros:boolean = false;
  public enableAdvertiseWithUs:boolean = false;
  
 
  isMenuOpen:boolean = false;
  pageName: string = null;
  needLoadedCount: number = 0; //need 3, 2 font and logo

  get strBlogUrl() {
      return this.service.advService.blogURL
  }

  get showUpgradeToPremiumLine(): boolean {
    if (!this.service.userService.isAuthenticated()) {
      return true;
    }

    return !(this.service.userService.isPremium() || this.service.userService.isAdmin() || this.service.userService.isDemo())
  }

  private subscription: Subscription;

  @ViewChild('menuButton', {static: false, read: ElementRef}) menuButton?: ElementRef<HTMLElement>;
  @ViewChild('snav', {static: false, read: ElementRef}) snavHTMLElement: ElementRef<HTMLElement>;
  @ViewChild('snav', {static: false}) snav: MatSidenav;

  constructor(private dialog: MatDialog, private _location: Location, private router: Router, public service: MainService, private _actionService: ActionService, private renderer: Renderer2) { 
    this.enableSubscription = service.enableSubscription;
    this.enableCompareVersion = service.enableCompareVersion;
    this.enableLetOurPros = service.enableLetOurPros;
    this.enableAdvertiseWithUs = service.enableAdvertiseWithUs;

    this.renderer.listen('window', 'click',(e:Event)=>{
      const snavEl = this.snavHTMLElement.nativeElement;
      if(e.target !== this.menuButton.nativeElement && e.target!==snavEl && !snavEl.contains( e.target as Node )){
          this.snav.close();
      }
    });
    
    WebFont.load({
      google: { families: ['Material Icons', 'Material Icons Outline'], },
      custom: {
        families: ['ETmodules']
      },
      fontactive: (familyName, fvd) => {
        if(familyName == "Material Icons" || "ETmodules") this.upAndCheckLoadedCount();
      },
    });

  }

  upAndCheckLoadedCount(){
    this.needLoadedCount++;
    if(this.needLoadedCount == 3){
      this.service.aplicationIsReady = true;
    }
  }

  getRouterUrl(){ 
    return this.router.url 
  };

  closeSnav(){
    window.scrollTo(0, 0)
    this.snav.close();
  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    this.subscription = this.service.observablePageName
    .subscribe(item => {
      this.pageName= item;
    });
  }
  
  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  locationBack() {
    if (window.history.length > 1) {
      this._location.back();
    } else {
      this.router.navigate(['/'])
    }
    document.getElementById('scroll-view-content').scrollTop =0;
  }

  public showCompareVersionsDialog() {
    let item = this.dialog.open(MobileCompareVersionsComponent, {
        width: '1000%',
        maxHeight: '100%',
        height: "82vh",
        panelClass: "CompareVersionsComponent-panel",
        data: {
            isPopup: true
        }
    });
    item.componentInstance.isPopup = true;
    return false;
  }
}
